import { render, staticRenderFns } from "./DisciplinaLista.vue?vue&type=template&id=a384c180&"
import script from "./DisciplinaLista.vue?vue&type=script&lang=js&"
export * from "./DisciplinaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports